var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustrationMaintenance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "723px",
    height: "203px",
    viewBox: "0 0 723 203",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "maintenance") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "maintenance",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "plug"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LHS",
    transform: "translate(0.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.283478,36 L221.283478,36 C221.835763,36 222.283478,36.4477153 222.283478,37 L222.283478,80 C222.283478,80.5522847 221.835763,81 221.283478,81 L178.283478,81 C177.731194,81 177.283478,80.5522847 177.283478,80 L177.283478,59 C177.283478,46.2974508 187.580929,36 200.283478,36 Z",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#000000",
    strokeWidth: 2,
    points: "222.331478 36 270.294478 36 270.294478 81 222.331478 81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.283478,81 L221.283478,81 C221.835763,81 222.283478,81.4477153 222.283478,82 L222.283478,125 C222.283478,125.552285 221.835763,126 221.283478,126 L200.283478,126 C187.580929,126 177.283478,115.702549 177.283478,103 L177.283478,82 C177.283478,81.4477153 177.731194,81 178.283478,81 Z",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#000000",
    strokeWidth: 2,
    points: "222.331478 81 270.294478 81 270.294478 126 222.331478 126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.283478,61 L176.198478,61 C176.750763,61 177.198478,61.4477153 177.198478,62 L177.198478,80 C177.198478,80.5522847 176.750763,81 176.198478,81 L131.283478,81 C130.731194,81 130.283478,80.5522847 130.283478,80 L130.283478,72 C130.283478,65.9248678 135.208346,61 141.283478,61 Z",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.283478,81 L176.198478,81 C176.750763,81 177.198478,81.4477153 177.198478,82 L177.198478,100 C177.198478,100.552285 176.750763,101 176.198478,101 L141.283478,101 C135.208346,101 130.283478,96.0751322 130.283478,90 L130.283478,82 C130.283478,81.4477153 130.731194,81 131.283478,81 Z",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5034783,69 L130.063478,69 C130.184981,69 130.283478,69.0984974 130.283478,69.22 L130.283478,90.78 C130.283478,90.9015026 130.184981,91 130.063478,91 L40.0634783,91 C34.2870632,91 28.7472349,88.705328 24.6626926,84.6207857 C20.5781503,80.5362434 18.2834783,74.9964151 18.2834783,69.22 C18.2834783,69.1616524 18.3066568,69.1056945 18.3479148,69.0644365 C18.3891728,69.0231785 18.4451307,69 18.5034783,69 Z",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2043775,23.0175818 C15.5434232,24.367344 16.6298377,25.9339963 17.4386572,27.6882836 C18.5879798,30.1769707 19.1711288,33.0358841 19.1711288,36.1833117 L19.1711288,67.9804006 L40.133535,67.9804006 C38.2562748,64.9701686 36.1463541,59.9796801 36.1463541,52.76279 L36.1463541,23.0175818 L14.2043775,23.0175818 M7.2834783,21 L38.1434394,21 L38.1434394,52.7617812 C38.1434394,64.707883 44.2834783,70 44.2834783,70 L17.1740434,70 L17.1740434,36.1843205 C17.1740434,23.6884277 7.2834783,21 7.2834783,21 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.42108547e-14,0 L15.5034783,0 C27.5322402,0 37.2834783,9.75123815 37.2834783,21.78 C37.2834783,21.9015026 37.1849809,22 37.0634783,22 L-1.42108547e-14,22",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.389478,46 L326.783478,46 C329.568251,46 332.238968,47.1062468 334.2081,49.0753788 C336.177231,51.0445108 337.283478,53.7152269 337.283478,56.5 C337.283478,59.2847731 336.177231,61.9554892 334.2081,63.9246212 C332.238968,65.8937532 329.568251,67 326.783478,67 L291.389478,67 C291.330936,67 291.283478,66.9525422 291.283478,66.894 L291.283478,46.106 C291.283478,46.0474578 291.330936,46 291.389478,46 Z",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.389478,93 L326.783478,93 C329.568251,93 332.238968,94.1062468 334.2081,96.0753788 C336.177231,98.0445108 337.283478,100.715227 337.283478,103.5 C337.283478,106.284773 336.177231,108.955489 334.2081,110.924621 C332.238968,112.893753 329.568251,114 326.783478,114 L291.389478,114 C291.330936,114 291.283478,113.952542 291.283478,113.894 L291.283478,93.106 C291.283478,93.0474578 291.330936,93 291.389478,93 Z",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#000000",
    strokeWidth: 2,
    points: "270.283478 25 291.283478 25 291.283478 81 270.283478 81"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#000000",
    strokeWidth: 2,
    points: "270.283478 81 291.283478 81 291.283478 136 270.283478 136"
  })), /*#__PURE__*/React.createElement("g", {
    id: "RHS",
    transform: "translate(577.283478, 89.000000) scale(-1, 1) translate(-577.283478, -89.000000) translate(431.283478, 21.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.283478,36 L221.283478,36 C221.835763,36 222.283478,36.4477153 222.283478,37 L222.283478,80 C222.283478,80.5522847 221.835763,81 221.283478,81 L178.283478,81 C177.731194,81 177.283478,80.5522847 177.283478,80 L177.283478,59 C177.283478,46.2974508 187.580929,36 200.283478,36 Z",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#000000",
    strokeWidth: 2,
    points: "222.331478 36 270.294478 36 270.294478 81 222.331478 81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.283478,81 L221.283478,81 C221.835763,81 222.283478,81.4477153 222.283478,82 L222.283478,125 C222.283478,125.552285 221.835763,126 221.283478,126 L200.283478,126 C187.580929,126 177.283478,115.702549 177.283478,103 L177.283478,82 C177.283478,81.4477153 177.731194,81 178.283478,81 Z",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#000000",
    strokeWidth: 2,
    points: "222.331478 81 270.294478 81 270.294478 126 222.331478 126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.283478,61 L176.198478,61 C176.750763,61 177.198478,61.4477153 177.198478,62 L177.198478,80 C177.198478,80.5522847 176.750763,81 176.198478,81 L131.283478,81 C130.731194,81 130.283478,80.5522847 130.283478,80 L130.283478,72 C130.283478,65.9248678 135.208346,61 141.283478,61 Z",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.283478,81 L176.198478,81 C176.750763,81 177.198478,81.4477153 177.198478,82 L177.198478,100 C177.198478,100.552285 176.750763,101 176.198478,101 L141.283478,101 C135.208346,101 130.283478,96.0751322 130.283478,90 L130.283478,82 C130.283478,81.4477153 130.731194,81 131.283478,81 Z",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5034783,69 L130.063478,69 C130.184981,69 130.283478,69.0984974 130.283478,69.22 L130.283478,90.78 C130.283478,90.9015026 130.184981,91 130.063478,91 L40.0634783,91 C34.2870632,91 28.7472349,88.705328 24.6626926,84.6207857 C20.5781503,80.5362434 18.2834783,74.9964151 18.2834783,69.22 C18.2834783,69.1616524 18.3066568,69.1056945 18.3479148,69.0644365 C18.3891728,69.0231785 18.4451307,69 18.5034783,69 Z",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2043775,23.0175818 C15.5434232,24.367344 16.6298377,25.9339963 17.4386572,27.6882836 C18.5879798,30.1769707 19.1711288,33.0358841 19.1711288,36.1833117 L19.1711288,67.9804006 L40.133535,67.9804006 C38.2562748,64.9701686 36.1463541,59.9796801 36.1463541,52.76279 L36.1463541,23.0175818 L14.2043775,23.0175818 M7.2834783,21 L38.1434394,21 L38.1434394,52.7617812 C38.1434394,64.707883 44.2834783,70 44.2834783,70 L17.1740434,70 L17.1740434,36.1843205 C17.1740434,23.6884277 7.2834783,21 7.2834783,21 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.42108547e-14,0 L15.5034783,0 C27.5322402,0 37.2834783,9.75123815 37.2834783,21.78 C37.2834783,21.9015026 37.1849809,22 37.0634783,22 L-1.42108547e-14,22",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#000000",
    strokeWidth: 2,
    points: "270.283478 25 291.283478 25 291.283478 81 270.283478 81"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#000000",
    strokeWidth: 2,
    points: "270.283478 81 291.283478 81 291.283478 136 270.283478 136"
  })), /*#__PURE__*/React.createElement("g", {
    id: "sparkles",
    transform: "translate(293.000000, 0.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93,18 C105.702549,18 116,28.2974508 116,41 L93,41 L93,18 Z",
    id: "Rectangle_185",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,157 L116,180 L93,180 C93,167.297451 103.297451,157 116,157 Z",
    id: "Rectangle_186",
    fill: "#3397BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,180 L26,180 C26,192.702549 15.7025492,203 3,203 L3,180 Z",
    id: "Rectangle_187",
    fill: "#F5AF2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L23,0 C23,12.7025492 12.7025492,23 0,23 L0,0 Z",
    id: "Rectangle_188",
    fill: "#FF652B"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationMaintenance);
export default __webpack_public_path__ + "static/media/illustration-maintenance.6250ece63cea72952c90c2b46823295a.svg";
export { ForwardRef as ReactComponent };